export default class Version {
    commit?: string
    tag?: string
    static unmarshal(json: any): Version | undefined {
        if (!json) {
            return undefined
        }
        var version = Object.assign(new Version(), json)
        if (json.time) {
            version.time = new Date(0)
            version.time.setUTCSeconds(json.time)
        }
        return version
    }
}
